/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {IntersectionObserverDirective as ɵa} from './lib/directives/intersection-observer.directive';